import type { ReactNode } from "react";

import type { ParsedTable } from "../lib/legal/parseTable";

type LegalTableProps = {
  table: ParsedTable;
  renderCell: (text: string) => ReactNode;
};

export function LegalTable({ table, renderCell }: LegalTableProps) {
  const colCount = table.headers.length;

  return (
    <div className="overflow-x-auto rounded-xl border border-border-soft shadow-sm">
      <table className="w-full min-w-[min(100%,36rem)] border-collapse text-left text-sm">
        <thead>
          <tr className="border-b border-border-soft bg-bg-subtle dark:bg-bg-muted">
            {table.headers.map((header) => (
              <th
                key={header}
                scope="col"
                className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-text-heading sm:text-sm sm:normal-case sm:tracking-normal"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="border-b border-border-soft last:border-b-0 odd:bg-bg-base even:bg-bg-subtle/60 dark:even:bg-bg-muted/40"
            >
              {Array.from({ length: colCount }, (_, colIndex) => (
                <td
                  key={colIndex}
                  className="px-4 py-3 align-top leading-relaxed text-text-body"
                >
                  {renderCell(row[colIndex] ?? "")}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
